module.exports = __webpack_public_path__ + "img/primary.c913c7e.svg";